const customSlide = () => {
  const sliderContainer = document.querySelector('.home-hero__main');
  if (!sliderContainer) return;
  sliderContainer.style.userSelect = 'none';
  sliderContainer.style.cursor = 'grab';

  const articles = document.querySelectorAll(
    '.article-card.article-card--bigbig',
  );

  if (articles.length <= 1) {
    console.warn('Non ci sono abbastanza articoli per creare uno slider.');
    return;
  }

  const totalSlides = articles.length;
  let currentIndex = 0;
  let autoSlideInterval;
  let isSliding = false;
  let startX = 0;
  let hasMoved = false;
  let startY = 0;

  const createDots = () => {
    const dotsContainer = document.createElement('div');
    dotsContainer.classList.add('slider-dots');

    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement('div');
      dot.classList.add('slider-dot');

      if (i === currentIndex) dot.classList.add('active');
      dot.addEventListener('click', () => goToSlide(i));
      dotsContainer.appendChild(dot);
    }

    sliderContainer.appendChild(dotsContainer);
  };

  const goToSlide = (index) => {
    if (isSliding) return;
    isSliding = true;
    hasMoved = true;
    currentIndex = index;
    updateSlider();
    updateDots();
    resetAutoSlide();
  };

  const updateDots = () => {
    const dots = document.querySelectorAll('.slider-dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentIndex);
    });
  };

  const updateSlider = () => {
    const translateXValue = -(currentIndex * 100);
    articles.forEach((article) => {
      article.style.transform = `translateX(${translateXValue}%)`;
      article.style.transition = 'transform 0.5s ease-in-out';
    });

    setTimeout(() => {
      isSliding = false;
    }, 500);
  };

  const slideNext = () => {
    goToSlide((currentIndex + 1) % totalSlides);
  };

  const slidePrev = () => {
    goToSlide(currentIndex > 0 ? currentIndex - 1 : totalSlides - 1);
  };

  const startAutoSlide = () => {
    autoSlideInterval = setInterval(slideNext, 5000);
  };

  const resetAutoSlide = () => {
    clearInterval(autoSlideInterval);
    startAutoSlide();
  };

  const handleSwipe = (start, end) => {
    const difference = start - end;
    hasMoved = Math.abs(difference) > 10;
    if (difference > 30) {
      slideNext();
    } else if (difference < -30) {
      slidePrev();
    }
  };

  const preventImageDrag = () => {
    const elements = sliderContainer.querySelectorAll('article, a, img');
    elements.forEach((el) => {
      el.addEventListener('dragstart', (e) => e.preventDefault());
      el.addEventListener('click', (e) => {
        if (hasMoved) {
          e.preventDefault();
          e.stopPropagation();
        }

        hasMoved = false;
      });
    });
  };

  const initSlider = () => {
    createDots();
    startAutoSlide();
    preventImageDrag();
    sliderContainer.addEventListener('mousedown', (e) => {
      if (isSliding) return;

      resetAutoSlide();
      startX = e.clientX;
      startY = e.clientY;
      hasMoved = false;
    });

    sliderContainer.addEventListener('mouseup', (e) => {
      if (isSliding) return;
      if (Math.abs(e.clientY - startY) < 20) {
        handleSwipe(startX, e.clientX);
      }
      resetAutoSlide();
    });

    sliderContainer.addEventListener('touchstart', (e) => {
      if (isSliding) return;
      resetAutoSlide();
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      hasMoved = false;
    });

    sliderContainer.addEventListener('touchend', (e) => {
      if (isSliding) return;
      if (Math.abs(e.changedTouches[0].clientY - startY) < 20) {
        handleSwipe(startX, e.changedTouches[0].clientX);
      }
      resetAutoSlide();
    });
  };

  initSlider();
};

export default {
  customSlide,
};
